
function PopupBtmAgreeUsage({ setisShowAgreeUsage }) {

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white z-11">
      <div className="h-[52px] border-b border-[#eee] flex w-full items-center justify-center relative">
        <h2 className="font-semibold text-[16px]">이용약관</h2>
        <button className="absolute right-0 p-4" onClick={() => setisShowAgreeUsage(false)}>
          <img src="/assets/img/close.svg" alt="close" />
        </button>
      </div>
      <div className="overflow-auto h-[calc(100%-52px)] px-5 py-7 text-[15px]">
        <h3 className="font-bold">제 1 조 (목적)</h3>
        <p>이 약관은 한국손해보상서비스(주)(이하 "회사")가 제공하는 다이렉트 보상 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무, 책임사항 및 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
        <br />

        <h3 className="font-bold">제 2 조 (정의)</h3>
        <ol className="ml-5 list-decimal">
          <li>"서비스"란 사고 차량의 차주에게 수리센터 접수 및 연결을 지원하는 다이렉트 보상 서비스를 의미합니다.</li>
          <li>"이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 자를 말합니다.</li>
        </ol>
        <br />

        <h3 className="font-bold">제 3 조 (약관의 효력 및 변경)</h3>
        <ol className="ml-5 list-decimal">
            <li>본 약관은 서비스 화면에 게시하거나 기타의 방법으로 공지함으로써 효력이 발생합니다.</li>
            <li>회사는 필요한 경우 관련 법령을 위반하지 않는 범위 내에서 약관을 변경할 수 있습니다.</li>
        </ol>
        <br />

        <h3 className="font-bold">제 4 조 (서비스의 이용)</h3>
        <ol className="ml-5 list-decimal">
            <li>회사는 이용자에게 사고 접수 및 수리센터 연결 지원 서비스를 제공합니다.</li>
            <li>이용자는 회사가 제공하는 절차에 따라 정확한 정보를 입력하여야 하며, 허위 정보로 인해 발생하는 문제는 이용자가 책임을 집니다.</li>
        </ol>
        <br />

        <h3 className="font-bold">제 5 조 (이용자의 의무)</h3>
        <ol className="ml-5 list-decimal">
            <li>이용자는 본 약관 및 관련 법령을 준수하여야 합니다.</li>
            <li>타인의 정보를 부정하게 이용하거나 회사의 정상적인 업무를 방해하는 행위를 해서는 안 됩니다.</li>
        </ol>
        <br />
        
        <h3 className="font-bold">제 6 조 (면책사항)</h3>
        <ol className="ml-5 list-decimal">
            <li>회사는 천재지변 또는 불가항력으로 인해 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.</li>
            <li>회사는 이용자의 귀책사유로 발생한 손해에 대해 책임을 지지 않습니다.</li>
        </ol>
        <br />
        
        <h3 className="font-bold">제 7 조 (기타)</h3>
        <ol className="ml-5 list-decimal">
            <li>본 약관에 명시되지 않은 사항은 관련 법령 또는 상관례에 따릅니다.</li>
            <li>본 약관의 해석과 관련된 분쟁은 대한민국 법률에 따르며, 관할 법원은 회사의 본사 소재지를 기준으로 합니다.</li>
        </ol>
      </div>
    </div>
  );
}

export default PopupBtmAgreeUsage;